import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AccountService } from '../account.service';
import { LicenseService } from '../license.service';
import { debounceTime, distinctUntilChanged, filter, flatMap, delay, finalize, catchError} from 'rxjs/operators';
import { Device } from '../models/kiosk';
import { License } from '../models/license';
import { MatSnackBar } from '@angular/material';
import { of } from 'rxjs';

@Component({
  selector: 'app-device-search',
  templateUrl: './device-search.component.html',
  styleUrls: ['./device-search.component.css'],
})
export class DeviceSearchComponent implements OnInit {
  @Output() emitDevice: EventEmitter<Device> = new EventEmitter<Device>();
  formGroup: FormGroup;
  deviceList: any[] = [];
  loading = false;
  selectedDevice?: Device;
  ls?: License[];
  constructor(
    private _fb: FormBuilder,
    private _accountService: AccountService,
    private _licenseService: LicenseService,
    private snackbar: MatSnackBar,
  ) {}

  ngOnInit() {
    this.createForm();
    this.setupAccountFilter();
  }

  createForm(): any {
    this.formGroup = this._fb.group({
        device: [''],
    });
  }

  setupAccountFilter() {
    const control = this.formGroup.get('device');
    control.valueChanges
      .pipe(
        debounceTime(500),
        filter(Boolean),
        distinctUntilChanged(),
        flatMap((val) => {
          this.loading = true;
          return this._accountService.findDevicesByImei(val).pipe(
            catchError(err => {
              console.error('could not get device', err);
              this.snackbar.open('Something went wrong', 'OK');
              return of([]);
            }),
          );
        }),

        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe((data) => {
        this.loading = false;
        this.deviceList = data;
      });
  }

  setDevice(item: Device) {
    console.log(item);
    this.formGroup.get('device').setValue('');
    this.emitDevice.emit(item);
    this.selectedDevice = item;

    this._licenseService.GetLicensesForDevice((<any>item).id).subscribe(ls => {
      console.log(ls);
      this.ls = ls.licenses;
    });
  }

  displayFnDevice(val: any) {
    return val.imei;
  }
}



// WEBPACK FOOTER //
// ./src/app/device-search/device-search.component.ts